import { useCallback, useContext } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import ModalContext from 'contexts/ModalContext'
import { selectLoggedIn } from 'selectors/accountSelectors'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import LoyaltyJoinModal from 'loyalty/components/LoyaltyJoinModal'
import enrolLoyaltyAccount from 'actions/loyalty/enrolLoyaltyAccount'

const messages = defineMessages({
  joinModalCta: {
    id: 'wplAbpygbWf4qiz85oAs',
    defaultMessage: 'Join Société for free',
    description: 'Primary CTA on the loyalty join modal when joining Société',
  },
})

/**
 * Returns a callback that starts the existing join-Société flow: logged-out users sign in first,
 * logged-in non-members open the loyalty join modal and, on confirmation, enrol. Mirrors the other
 * "Join Société" CTAs (e.g. LoyaltyPurchasePointsNeedsMembershipCta).
 */
export default function useJoinSociete() {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const showModal = useContext(ModalContext)
  const isLoggedIn = useAppSelector(selectLoggedIn)

  return useCallback(async() => {
    if (!isLoggedIn) {
      showModal(<AccountAccessModal />)
      return
    }
    const joinConfirmed = await showModal<boolean>(
      <LoyaltyJoinModal onAfterClose={() => {}} primaryActionCta={intl.formatMessage(messages.joinModalCta)} />,
    )
    if (joinConfirmed) {
      dispatch(enrolLoyaltyAccount({ enrolment: 'existingUserRegistration' }))
    }
  }, [isLoggedIn, showModal, dispatch, intl])
}
